/**
 * Winwin — followed auctions (browser storage + optional notifications).
 * Selloff has lot bookmarks, not auction follows. Overbid emails are handled by Selloff
 * for registered bidders; sale-open alerts use the browser Notification API when allowed.
 */
(function (global) {
  var KEY = 'ww_followed_auctions';
  var ALERT_KEY = 'ww_follow_alerted';

  function read() {
    try {
      var raw = localStorage.getItem(KEY);
      var list = raw ? JSON.parse(raw) : [];
      return Array.isArray(list) ? list : [];
    } catch (e) {
      return [];
    }
  }

  function write(list) {
    try {
      localStorage.setItem(KEY, JSON.stringify(list || []));
    } catch (e) { /* ignore quota */ }
  }

  function readAlerted() {
    try {
      var raw = localStorage.getItem(ALERT_KEY);
      var map = raw ? JSON.parse(raw) : {};
      return map && typeof map === 'object' ? map : {};
    } catch (e) {
      return {};
    }
  }

  function writeAlerted(map) {
    try {
      localStorage.setItem(ALERT_KEY, JSON.stringify(map || {}));
    } catch (e) { /* ignore */ }
  }

  function list() {
    return read();
  }

  function find(idauction) {
    var id = String(idauction == null ? '' : idauction);
    return read().find(function (item) {
      return String(item.idauction) === id;
    }) || null;
  }

  function isFollowing(idauction) {
    return !!find(idauction);
  }

  function follow(auction, opts) {
    opts = opts || {};
    if (!auction || auction.idauction == null) return null;
    var listItems = read().filter(function (item) {
      return String(item.idauction) !== String(auction.idauction);
    });
    var entry = {
      idauction: auction.idauction,
      name: auction.name || auction.translated_name || 'Auction',
      from_date: auction.from_date || '',
      to_date: auction.to_date || '',
      date: auction.date || '',
      notify: opts.notify !== false,
      followed_at: new Date().toISOString()
    };
    listItems.unshift(entry);
    write(listItems);
    return entry;
  }

  function unfollow(idauction) {
    write(read().filter(function (item) {
      return String(item.idauction) !== String(idauction);
    }));
  }

  function requestNotifyPermission() {
    if (!('Notification' in global)) {
      return Promise.resolve('unsupported');
    }
    if (Notification.permission === 'granted' || Notification.permission === 'denied') {
      return Promise.resolve(Notification.permission);
    }
    return Notification.requestPermission();
  }

  function todayYmdZurich() {
    return new Intl.DateTimeFormat('en-CA', {
      timeZone: 'Europe/Zurich',
      year: 'numeric',
      month: '2-digit',
      day: '2-digit'
    }).format(new Date());
  }

  function openYmd(item) {
    var from = item && (item.from_date || item.date || '');
    var m = String(from).match(/^(\d{4})-(\d{2})-(\d{2})/);
    return m ? (m[1] + '-' + m[2] + '-' + m[3]) : '';
  }

  /** Fire a one-time browser alert when a followed sale has reached its open date. */
  function checkOpenAlerts(auction) {
    if (!auction || auction.idauction == null) return;
    if (!('Notification' in global) || Notification.permission !== 'granted') return;
    var entry = find(auction.idauction);
    if (!entry || entry.notify === false) return;
    var ymd = openYmd(entry) || openYmd(auction);
    if (!ymd || todayYmdZurich() < ymd) return;
    var alerted = readAlerted();
    var key = String(auction.idauction) + ':' + ymd;
    if (alerted[key]) return;
    try {
      new Notification('Winwin Genève', {
        body: (entry.name || 'Your followed auction') + ' is now open.',
        tag: 'ww-auction-open-' + auction.idauction
      });
      alerted[key] = true;
      writeAlerted(alerted);
    } catch (e) { /* ignore */ }
  }

  global.WinwinFollows = {
    list: list,
    find: find,
    isFollowing: isFollowing,
    follow: follow,
    unfollow: unfollow,
    requestNotifyPermission: requestNotifyPermission,
    checkOpenAlerts: checkOpenAlerts
  };
})(window);
